/**
 * AUTO-GENERATED by scripts/generate-services.mjs — DO NOT EDIT.
 * Re-generate: pnpm api:gen
 */
import axios from '../index';
import type { paths } from '@/typings/openapi';

// tag: 用户分享

/** 获取分享列表 */
export const getUserShareAttempts = (params?: {
    page?: string;
    size?: string;
    status?: "pending_approval" | "rejected" | "approved";
  }) => {
  return axios<paths['/v1/user-share-attempts']['get'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>('/v1/user-share-attempts', {
    method: 'get',
    params,
  });
};

/** 审核通过 */
export const postUserShareAttemptsByAttemptIdApprove = (attemptId: string) => {
  return axios<paths['/v1/user-share-attempts/{attemptId}/approve']['post'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>(`/v1/user-share-attempts/${attemptId}/approve`, {
    method: 'post',
  });
};

/** 修改分享指标数据（播放/点赞/转发） */
export const postUserShareAttemptsByAttemptIdMetrics = (attemptId: string, data?: paths['/v1/user-share-attempts/{attemptId}/metrics']['post'] extends { requestBody?: { content: { 'application/json': infer B } } } ? B : unknown) => {
  return axios<paths['/v1/user-share-attempts/{attemptId}/metrics']['post'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>(`/v1/user-share-attempts/${attemptId}/metrics`, {
    method: 'post',
    data,
  });
};

/** 审核拒绝 */
export const postUserShareAttemptsByAttemptIdReject = (attemptId: string, data?: paths['/v1/user-share-attempts/{attemptId}/reject']['post'] extends { requestBody?: { content: { 'application/json': infer B } } } ? B : unknown) => {
  return axios<paths['/v1/user-share-attempts/{attemptId}/reject']['post'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>(`/v1/user-share-attempts/${attemptId}/reject`, {
    method: 'post',
    data,
  });
};

/** 定稿活动 */
export const postUserShareAttemptsActivitiesByActivityIdFinalize = (activityId: string, data?: paths['/v1/user-share-attempts/activities/{activityId}/finalize']['post'] extends { requestBody?: { content: { 'application/json': infer B } } } ? B : unknown) => {
  return axios<paths['/v1/user-share-attempts/activities/{activityId}/finalize']['post'] extends { responses: { 200: { content: { 'application/json': infer R } } } } ? R : unknown>(`/v1/user-share-attempts/activities/${activityId}/finalize`, {
    method: 'post',
    data,
  });
};
